"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    UrlHelper.prototype.setPhotoRewrite = function (value) {
        this.s3PhotoRewrite = value;
    };
    UrlHelper.prototype.setUrl = function (value) {
        this.s3Url = value;
    };
    UrlHelper.prototype.getUrl = function (value) {
        if (!value) {
            return null;
        }
        var requestUri = value;
        if (this.s3PhotoRewrite) {
            requestUri = requestUri.replace('/photos/', "/" + this.s3PhotoRewrite + "/");
        }
        return this.s3Url + requestUri;
    };
    UrlHelper.prototype.getMtvaUrl = function (value, size) {
        if (!value) {
            return null;
        }
        var mtvaSize = 'small';
        if ('lg' === size) {
            mtvaSize = 'watermark';
        }
        return "https://archivum.mtva.hu/images/" + mtvaSize + "/" + value;
    };
    return UrlHelper;
}());
var urlHelper = new UrlHelper();
exports.default = urlHelper;
